import React from 'react';
import { X } from 'lucide-react';
import { FaWrench, FaHandHoldingMedical } from "react-icons/fa6";
import { GiHorseHead } from 'react-icons/gi';

const ZoneOptionsModal = ({ 
  isOpen, 
  onClose, 
  zone, 
  onMoveAllHorses, 
  horsesInZone,
  onReportTechnicalIncident,
  onReportAnimalIncident // On garde le même nom pour compatibilité avec HorseMap.jsx
}) => {
  if (!isOpen || !zone) return null;

  const hasHorses = horsesInZone && horsesInZone.length > 0;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10000]">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 m-4">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold">Zone: {zone.name}</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-3">
          {/* Option 1: Signaler un incident matériel/technique */}
          <button
            onClick={() => {
              onReportTechnicalIncident(zone);
              onClose();
            }}
            className="w-full p-4 bg-purple-50 hover:bg-purple-100 border-2 border-purple-300 rounded-lg transition-colors flex items-center gap-3"
          >
            <FaWrench className="h-5 w-5 text-purple-600" />
            <div className="text-left">
              <div className="font-semibold text-purple-900">Signaler un incident technique</div>
              <div className="text-sm text-purple-700">Infrastructure, matériel, clôture...</div>
            </div>
          </button>

          {/* Option 2: Signaler un incident médical */}
          <button
            onClick={() => {
              if (hasHorses) {
                onReportAnimalIncident(zone);
                onClose();
              }
            }}
            className={`w-full p-4 rounded-lg transition-colors flex items-center gap-3 ${
              hasHorses 
                ? 'bg-blue-50 hover:bg-blue-100 border-2 border-blue-300' 
                : 'bg-gray-100 border-2 border-gray-300 opacity-50 cursor-not-allowed'
            }`}
            disabled={!hasHorses}
          >
            <FaHandHoldingMedical className={`h-5 w-5 ${hasHorses ? 'text-blue-600' : 'text-gray-400'}`} />
            <div className="text-left">
              <div className={`font-semibold ${hasHorses ? 'text-blue-900' : 'text-gray-500'}`}>
                Signaler un incident médical
              </div>
              <div className={`text-sm ${hasHorses ? 'text-blue-700' : 'text-gray-400'}`}>
                {hasHorses 
                  ? `${horsesInZone.length} animal${horsesInZone.length > 1 ? 'aux' : ''} dans cette zone`
                  : 'Aucun animal dans cette zone'
                }
              </div>
            </div>
          </button>

          {/* Option 3: Déplacer tous les chevaux */}
          <button
            onClick={() => {
              if (hasHorses) {
                onMoveAllHorses();
              }
            }}
            className={`w-full p-4 rounded-lg transition-colors flex items-center gap-3 ${
              hasHorses 
                ? 'bg-green-50 hover:bg-green-100 border-2 border-green-300' 
                : 'bg-gray-100 border-2 border-gray-300 opacity-50 cursor-not-allowed'
            }`}
            disabled={!hasHorses}
          >
            <GiHorseHead className={`h-5 w-5 ${hasHorses ? 'text-green-600' : 'text-gray-400'}`} />
            <div className="text-left">
              <div className={`font-semibold ${hasHorses ? 'text-green-900' : 'text-gray-500'}`}>
                Déplacer tous les animaux
              </div>
              <div className={`text-sm ${hasHorses ? 'text-green-700' : 'text-gray-400'}`}>
                {hasHorses 
                  ? `Déplacer les ${horsesInZone.length} animaux vers une autre zone`
                  : 'Aucun animal à déplacer'
                }
              </div>
            </div>
          </button>
        </div>

        <div className="mt-6 pt-4 border-t">
          <button
            onClick={onClose}
            className="w-full px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};

export default ZoneOptionsModal;